const isObject = (value) => typeof value === 'object' && value !== null;
const asNonEmptyString = (value) => {
    if (typeof value !== 'string')
        return null;
    const trimmed = value.trim();
    return trimmed.length ? trimmed : null;
};
const asNumber = (value) => {
    if (typeof value !== 'number' || Number.isNaN(value))
        return null;
    return value;
};
const messageFromData = (data) => {
    if (!isObject(data))
        return null;
    const fromMessage = asNonEmptyString(data.message);
    if (fromMessage)
        return fromMessage;
    const fromError = asNonEmptyString(data.error);
    if (fromError)
        return fromError;
    // Common validation shape: { error: string[] }
    const errorArray = data.error;
    if (Array.isArray(errorArray)) {
        const first = asNonEmptyString(errorArray[0]);
        if (first)
            return first;
    }
    return null;
};
const messageFromUnknown = (value) => {
    // Unwrap TanStack Start-style wrapper: { $error: ... }
    if (isObject(value) && '$error' in value) {
        const unwrapped = value.$error;
        const msg = messageFromUnknown(unwrapped);
        if (msg)
            return msg;
    }
    if (value instanceof Error) {
        const msg = asNonEmptyString(value.message);
        if (msg)
            return msg;
    }
    if (typeof value === 'string')
        return asNonEmptyString(value);
    if (typeof value === 'number')
        return String(value);
    if (typeof value === 'boolean')
        return String(value);
    if (!isObject(value))
        return null;
    const errObj = value;
    // AxiosError-like: error.response.data.message
    if (isObject(errObj.response)) {
        const response = errObj.response;
        const msg = messageFromData(response?.data);
        if (msg)
            return msg;
    }
    // ServerFn thrown object: { status, data: { message } }
    const msgFromData = messageFromData(errObj.data);
    if (msgFromData)
        return msgFromData;
    // Generic object with message/error field
    const directMessage = asNonEmptyString(errObj.message);
    if (directMessage)
        return directMessage;
    const directError = asNonEmptyString(errObj.error);
    if (directError)
        return directError;
    return null;
};
const nameFromUnknown = (value) => {
    if (value instanceof Error)
        return asNonEmptyString(value.name);
    if (!isObject(value))
        return null;
    return asNonEmptyString(value.name);
};
const statusFromUnknown = (value) => {
    if (!isObject(value))
        return null;
    const direct = asNumber(value.status);
    if (direct !== null)
        return direct;
    if (isObject(value.response)) {
        const fromResponse = asNumber(value.response?.status);
        if (fromResponse !== null)
            return fromResponse;
    }
    if (isObject(value.data)) {
        const fromData = asNumber(value.data?.status);
        if (fromData !== null)
            return fromData;
    }
    return null;
};
const codeFromUnknown = (value) => {
    if (!isObject(value))
        return null;
    const direct = asNonEmptyString(value.code);
    if (direct)
        return direct;
    if (isObject(value.data)) {
        const fromData = asNonEmptyString(value.data?.code);
        if (fromData)
            return fromData;
    }
    if (isObject(value.response)) {
        const fromResponse = asNonEmptyString(value.response?.data?.code);
        if (fromResponse)
            return fromResponse;
    }
    return null;
};
export function parseError(error) {
    const original = error;
    const unwrapped = isObject(error) && '$error' in error
        ? error.$error
        : error;
    return {
        error: unwrapped ?? original,
        message: messageFromUnknown(unwrapped),
        name: nameFromUnknown(unwrapped),
        status: statusFromUnknown(unwrapped),
        code: codeFromUnknown(unwrapped),
    };
}
//# sourceMappingURL=parseError.js.map